import { createSlice } from '@reduxjs/toolkit';
import { BannerResponse, getBanners } from './bannersActions';
 
interface InitialState {
  itemsSuccess: boolean;
  itemsData: undefined | BannerResponse;
  itemsLoading: boolean;
  itemsError: boolean;
 
}

const initialState: InitialState = {
  itemsSuccess: false,
  itemsData: undefined,
  itemsLoading: false,
  itemsError: false,
};

const bannersSlice = createSlice({
  name: 'banners',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getBanners.rejected, (state: InitialState) => {
      state.itemsError = true;
      state.itemsLoading = false;
      state.itemsSuccess = false;
      state.itemsData = undefined;
    });
    builder.addCase(getBanners.pending, (state: InitialState) => {
      state.itemsError = false;
      state.itemsLoading = true;
      state.itemsSuccess = false;
    });
    builder.addCase(getBanners.fulfilled, (state: InitialState, action) => {
      state.itemsData = action.payload;
      state.itemsError = false;
      state.itemsLoading = false;
      state.itemsSuccess = true;
    });
   
  },
});

export default bannersSlice.reducer;
